var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ]
    },
    [
      _vm.isPlatform
        ? _c("div", { staticStyle: { height: "500px" } }, [
            _vm._v("\n    平台化商家不能参与小店分发项目\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isPlatform
        ? _c(
            "el-form",
            {
              ref: "storeDis",
              attrs: {
                model: _vm.form,
                "label-width": "140px",
                rules: _vm.formDataRules,
                "show-message": _vm.storeInOpen,
                "hide-required-asterisk": _vm.storeInClose
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "是否参与小店分发",
                    prop: "is_participation_dispense",
                    "label-width": "140px"
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      on: { change: _vm.handleChange },
                      model: {
                        value: _vm.form.is_participation_dispense,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "is_participation_dispense", $$v)
                        },
                        expression: "form.is_participation_dispense"
                      }
                    },
                    [
                      _c("el-option", { attrs: { label: "开启", value: "1" } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "关闭", value: "2" } })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.storeInClose,
                          expression: "storeInClose"
                        }
                      ],
                      staticClass: "select-option-tips"
                    },
                    [
                      _vm._v(
                        "\n        成功“关闭”后，所有设置失效，开单不会扣除佣金。\n      "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-card",
                { staticClass: "shop-card", attrs: { shadow: "never" } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "协议生效日期",
                        prop: "effective_date",
                        "label-width": "140px"
                      }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "date",
                                  "picker-options": _vm.pickerOptions,
                                  "value-format": "yyyy-MM-dd",
                                  disabled: _vm.storeInClose
                                },
                                model: {
                                  value: _vm.form.effective_date,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "effective_date", $$v)
                                  },
                                  expression: "form.effective_date"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.form.effective_date,
                                    expression: "form.effective_date"
                                  }
                                ],
                                staticClass: "select-option-tips"
                              },
                              [
                                _vm._v("\n              从"),
                                _c("span", { staticClass: "tip" }, [
                                  _vm._v(_vm._s(_vm.nextDay) + " 7:00的")
                                ]),
                                _vm._v(
                                  "专场日起，只要参与「小店渠道分发」所生成的采购计划（"
                                ),
                                _c("span", { staticClass: "tip" }, [
                                  _vm._v(_vm._s(_vm.afterTomorrow) + " 7:00起")
                                ]),
                                _vm._v(
                                  "），在开单中每件商品都将会被扣除X%的「小店佣金服务费」。前置仓账单、买赔账单同理在"
                                ),
                                _c("span", { staticClass: "tip" }, [
                                  _vm._v(_vm._s(_vm.afterTomorrow) + " 7:00起")
                                ]),
                                _vm._v("对生产的账单进行扣佣。\n            ")
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "抽佣比例", prop: "checkList" } },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          model: {
                            value: _vm.form.checkList,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "checkList", $$v)
                            },
                            expression: "form.checkList"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "checkbox-wrap" },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  attrs: {
                                    disabled: _vm.storeInClose,
                                    label: "normal_rate"
                                  },
                                  model: {
                                    value: _vm.form.checked_normal_rate,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "checked_normal_rate",
                                        $$v
                                      )
                                    },
                                    expression: "form.checked_normal_rate"
                                  }
                                },
                                [
                                  _c("span", { staticClass: "tip" }, [
                                    _vm._v("正价")
                                  ]),
                                  _vm._v("抽佣比例\n            ")
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "ys-input",
                                {
                                  style: { width: "200px", marginLeft: "8px" },
                                  attrs: {
                                    pattern: "positiveInt",
                                    min: "1",
                                    max: "100",
                                    disabled:
                                      !_vm.form.checkList.includes(
                                        "normal_rate"
                                      ) || _vm.storeInClose,
                                    placeholder: "采购单商品抽佣比例"
                                  },
                                  model: {
                                    value: _vm.form.normal_rate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "normal_rate", $$v)
                                    },
                                    expression: "form.normal_rate"
                                  }
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v(" % ")
                                  ])
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "checkbox-wrap second" },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  attrs: {
                                    disabled: _vm.storeInClose,
                                    label: "special_offer_rate"
                                  },
                                  model: {
                                    value: _vm.form.checked_special_offer_rate,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "checked_special_offer_rate",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.checked_special_offer_rate"
                                  }
                                },
                                [
                                  _c("span", { staticClass: "tip" }, [
                                    _vm._v("特价")
                                  ]),
                                  _vm._v("抽佣比例\n            ")
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "ys-input",
                                {
                                  style: { width: "200px", marginLeft: "8px" },
                                  attrs: {
                                    pattern: "positiveInt",
                                    min: "1",
                                    max: "100",
                                    disabled:
                                      !_vm.form.checkList.includes(
                                        "special_offer_rate"
                                      ) || _vm.storeInClose,
                                    placeholder: "采购单商品抽佣比例"
                                  },
                                  model: {
                                    value: _vm.form.special_offer_rate,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "special_offer_rate",
                                        $$v
                                      )
                                    },
                                    expression: "form.special_offer_rate"
                                  }
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v(" % ")
                                  ])
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-top": "20px", "margin-left": "800px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.handleSubmit }
                },
                [_vm._v("提交")]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26ca4a8d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26ca4a8d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/supply/updateSupplyComponents/StoreDistribute.vue
// module id = null
// module chunks = 